var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ParameterizedRemoteData } from "../Infra/RemoteData";
import { observable } from "mobx";
import { StatsInterval } from "healthex-common/stats.dtos";
export class StatsManager {
    constructor(statsService, invalidationManager, authManager) {
        this.statsService = statsService;
        this.invalidationManager = invalidationManager;
        this.authManager = authManager;
        this.overviewTimelineDailyStatsForOrganization = new ParameterizedRemoteData(this.invalidationManager, () => this.authManager.orgId, () => this.loadOverviewTimelineDailyStatsForOrganization());
    }
    async loadOverviewTimelineDailyStatsForOrganization() {
        if (!this.authManager.orgId)
            return null;
        return await this.statsService.getStatsOverviewTimelineForOrganization(this.authManager.orgId, StatsInterval.DAILY, 90);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], StatsManager.prototype, "overviewTimelineDailyStatsForOrganization", void 0);
